function DefaultAcctsCustRetrievalService($resource, $window) {

    return $resource(__styleEnv__ + 'customizations/Default/AccountsDefaultCustomization.json', {},
        {
            query: {
                method: 'GET',
                isArray: false,
                cache: true
            }
        });
}
DefaultAcctsCustRetrievalService.$inject = ['$resource', '$window'];

export default DefaultAcctsCustRetrievalService;
